import { graphql, useStaticQuery } from "gatsby"

import { QueryFragments } from "./queryFragments"

export const useBlogRecentPosts = () => {
  const { allSanityPost } = useStaticQuery(graphql`
    query {
      allSanityPost {
        nodes {
          ...BlogCardFields
        }
      }
    }
  `)
  return allSanityPost.nodes || []
}
